import React from "react";
import { BrowserRouter } from "react-router-dom";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
import axios from "axios";

const container = document.getElementById("root");
const root = createRoot(container);

axios.defaults.baseURL = "https://moviesapi.ir/api/v1";

root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);
